import { LessonPlan } from "@/models/lessonPlan.model";
import { LessonPlanRest } from "@/services/rest/lessonPlan.rest";
import { BehaviorSubject, map, take } from "rxjs";

export class LessonPlanService {
  constructor(private _lessonPlan = new LessonPlanRest()) {}

  private materials$ = new BehaviorSubject<any>([]);
  materials = this.materials$.asObservable();

  private lessonPlans$ = new BehaviorSubject<LessonPlan[]>([]);
  lessonPlans = this.lessonPlans$.asObservable();

  private lessonPlan$ = new BehaviorSubject<LessonPlan>({} as LessonPlan);
  lessonPlan = this.lessonPlan$.asObservable();

  getMaterialsByLessonPlan(lessonPlanId: string): void {
    this._lessonPlan
      .getMaterialsByLessonPlan(lessonPlanId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.materials$.next(response);
        },
      });
  }
  getLessonPlan(learningOjectiveId: string): void {
    this._lessonPlan
      .getLessonPlan(learningOjectiveId)
      .pipe(
        take(1),
        map((e) => {
          e.sort((a, b) => {
            if (a.name === "ESSENTIAL") return -1;
            if (b.name === "ESSENTIAL") return 1;
            return 0;
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.lessonPlans$.next(response);
        },
      });
  }

  getLessonPlanById(learningOjectiveId: string, lessonPlanId: string): void {
    this._lessonPlan
      .getLessonPlanById(learningOjectiveId, lessonPlanId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.lessonPlan$.next(response);
        },
      });
  }
}
